export default __webpack_public_path__ + "static/media/greenbrilliance-logo.b08fccc2.png";